import _ from 'lodash';
import { useHistory } from 'react-router-dom';

export default function useSearchParams(defaultKeyValuePairs) {
  const history = useHistory();
  const searchParams = new URLSearchParams(history.location.search);

  const setSearchParams = (keyValuePairs) => {
    const keys = Object.keys(keyValuePairs);

    keys.forEach((key) => {
      const value = keyValuePairs[key];

      if ((key === 'searchBy') && (keyValuePairs.search == null)) {
        searchParams.delete('search');
        searchParams.set(key, value);
      } else {
        searchParams.set(key, value);
      }
    });

    history.location.search = `?${searchParams.toString()}`;
    history.push(history.location.search);
  };

  for (const [key, value] of _.toPairs(defaultKeyValuePairs)) {
    if (!searchParams.has(key) && !_.isNil(value)) {
      searchParams.set(key, value);
    }
  }

  return [searchParams, setSearchParams];
}
